import { buildModelManager } from "../builder.js";
const DefaultSessionSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  roles: { key: true, name: true },
  shopId: true,
  shopifySID: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "session";
const pluralModelApiIdentifier = "sessions";
;
;
const operations = [
  {
    type: "get",
    operationName: "currentSession",
    defaultSelection: DefaultSessionSelection,
    modelApiIdentifier,
    namespace: null
  },
  {
    type: "action",
    operationName: "update",
    operationReturnType: "UpdateSession",
    functionName: "update",
    namespace: "currentSession",
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { session: { required: false, type: "UpdateSessionInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSessionSelection
  }
];
const CurrentSessionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSessionSelection,
  operations
);
export {
  CurrentSessionManager,
  DefaultSessionSelection
};
//# sourceMappingURL=CurrentSession.js.map
